module.exports = __webpack_public_path__ + "assets-cabinet/img/iban-icon.9828ddc5.svg";